<template>
<div class="form-body">
  <div class="row">
    <div class="form-holder">
      <div class="form-content">
        <div class="form-items">
          <span class="logo-lg"><img class="img" src="../../../assets/img/logo-black.png"></span>
          <div class="container" style="width: 100% !important;">
            <div class="col-md-12">
              <div class="box">
                <div class="box-body">
                  <img class="img" src="../../../assets/img/meeting_pending.svg">
                  <h4 class="box-title">Your interview session will start at</h4>
                   <span><span class="color-g">{{getDate(start_datetime)}}</span> at <span class="color-g">{{getTime(start_datetime)}} to {{getTime(end_datetime)}} {{currentTimezone}}</span></span>

                </div>
                <div class="box-footer clearfix" style="background-color: #F5F5F5;">
                  <span class="text-muted">Be connected</span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import axios from 'axios'
import { BaseURL } from '../../../shared/classes'
import { logo } from '../../../shared/svg'
import momentsone from 'moment-timezone'
import moment from 'moment'
import router from '../../../router/index'
export default {
  data () {
    return {
      form: {
        email: '',
        name: '',
        channel: ''
      },
      joinBtn: false,
      BaseURL: BaseURL,
      meetingid_error: false,
      meetingid: '',
      baseMode: 'avc',
      transcode: 'interop',
      attendeeMode: 'video',
      videoProfile: '480p_4',
      logos: logo,
      start_datetime: '',
      end_datetime: '',
      timezone: momentsone.tz.guess(),
      currentTimezone: 'IST',
      timeInt: '',
      data: [],
      config: {
        headers: {
          'content-type': 'application/json'
          // Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
    }
  },
  created () {
    console.log(this.$route.params.id)
    Cookies.set('sid', this.$route.params.id)
    this.getscheduleDetails(this.$route.params.id)
    if (this.timezone === 'America/New_York') {
      this.currentTimezone = 'EST'
    } else {
      this.currentTimezone = 'IST'
    }
    this.timeInt = setInterval(this.fetchEventsList, 60000)
  },
  methods: {
    fetchEventsList () {
      console.log('welcome', new Date())
      var currentDate = new Date()
      this.current_date = moment(String(currentDate)).utc().format('YYYYMMDDHHmm')
      var scheduledate = moment.utc(this.start_datetime).subtract(5, 'minutes').toDate()
      scheduledate = moment.utc(scheduledate).format('YYYYMMDDHHmm')
      var endtime = moment.utc(this.end_datetime).format('YYYYMMDDHHmm')
      if (this.current_date >= scheduledate && this.current_date < endtime) {
        clearInterval(this.timeInt)
        router.push({ name: 'AgoraHome', params: { id: this.$route.params.id, type: this.$route.params.type } })
      }
    },
    getDate (date) {
      console.log(date, this.timezone)
      return momentsone.utc(date).tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return momentsone.utc(date).tz(this.timezone).format('hh:mm a')
    },
    getscheduleDetails (id) {
      const mainurl = '/dashboard/get_schedule_detail/' + id
      axios.get(`${this.BaseURL}${mainurl}`, this.config).then(response => {
        if (response.data.refer_tag !== 'self') {
          this.data = response.data.scheduleList[0]
        } else {
          this.data = response.data.scheduleList_self[0]
        }
        this.meetingid = this.data.meeting_id
        this.end_datetime = this.data.enddatetime_utc
        this.start_datetime = this.data.startdatetime_utc
        if (this.data.job_interview_type === 'video') {
          this.attendeeMode = 'video'
        } else {
          this.attendeeMode = 'audio-only'
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.passwardcompare {
  margin-top: 9px !important;
}
.img {
    width: 30% !important;
    margin-bottom: 15px;
}
.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: 0px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.form-holder {
  margin-left: 0px;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  width: 44%;
  margin-left: 3%;
  margin-right: 3%;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5bad2b;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5bad2b;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
.form-content {
    width: auto;
}
.box {
  border-top: 0px solid #d2d6de;
  border-radius: 0px;
}
.form-content form {
    margin-bottom: 30px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
}
.box-header .box-title {
    display: inline-block;
    font-size: 16px;
    margin: 0;
    line-height: 1;
    color:black;
}
.form-content .form-items {
    max-width: 540px;
}
html {
  height: 100% !important;
}
.form-content {
  background-color: #F5F5F5 !important;
}
.form-body {
  background-color: #F5F5F5 !important;
}
input {
  background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #DCDCDC;
}
.color-g {
  color: #5bad2b;
}
</style>
